import firebaseServices, { analytics } from "./firebase"; // adjust path if needed

// Firebase Analytics event params are just key-value objects
export type AnalyticsParams = Record<string, unknown>;

export type AnalyticsEventName =
  | "page_view"
  | "click"
  | "select_content"
  | "view_item"
  | "generate_lead"
  | "login"
  | "sign_up"
  | "search"
  | "share"
  | (string & {}); // allow custom strings

export interface TrackEventOptions {
  name: AnalyticsEventName;
  page?: string;
  action?: string;
  label?: string;
  value?: number;
  params?: AnalyticsParams;
}

/**
 * Safely track an analytics event.
 */
export function trackEvent({
  name,
  page,
  action,
  label,
  value,
  params = {},
}: TrackEventOptions): void {
  if (typeof window === "undefined") return; // SSR guard
  if (!analytics) return; // analytics not initialized

  const payload: AnalyticsParams = {
    page_location: page ?? window.location.pathname,
    action,
    label,
    value,
    ...params,
  };

  // Clean up undefineds
  Object.keys(payload).forEach((k) => {
    if (payload[k] === undefined) delete payload[k];
  });

  try {
    firebaseServices.logEvent(analytics, name, payload);
  } catch (err) {
    if (process.env.NODE_ENV === "development") {
      console.warn("Analytics event failed:", err);
    }
  }
   if (process.env.NODE_ENV === "development") {
        // console.log("Analytics event:", name, payload);
    }
}

/** Track a page view (call on route change). */
export function pageView(page?: string): void {
  trackEvent({ name: "page_view", page });
}